import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormControl, FormGroup, Validators, FormBuilder, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'request-list-filter',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './request-list-filter.component.html',
  styleUrl: './request-list-filter.component.css'
})

export class RequestListFilterComponent implements OnInit {
  IsHidden: boolean = false;
  today = new Date();
  filterForm = new FormGroup({
    reference: new FormControl(''),
    hospitalNum: new FormControl(''),
    labNumber: new FormControl(''),
    surname: new FormControl(''),
    forename: new FormControl( ''),
    dob: new FormControl(''),
    email: new FormControl(''),
    toDate: new FormControl((new Date()).toISOString().substring(0, 10)),
    fromDate: new FormControl(((new Date()).addDays(-14)).toISOString().substring(0, 10))
  });

@Output() onFilter = new EventEmitter<any>();
  constructor(private formBulder: FormBuilder) {

  }

  ngOnInit() {
    //this.buildForm();
  }

  buildForm() {
    const today = new Date();
    //this.filterForm = this.formBulder.group({
    //  reference: '',
    //  hospitalNum: '',
    //  labNumber: '',
    //  surname: [''],
    //  forename: [''],
    //  email: '',
    //  dob: '',
    //  fromDate: '',
    //  toDate: ''
    //});
    // @ts-ignore
    //this.filterForm.setValue({
    //  reference: '',
    //  hospitalNum: '',
    //  labNumber: '',
    //  surname: '',
    //  forename: '',
    //  dob: '',
    //  email: '',
    //  toDate: today.toISOString().substring(0, 10),
    //  fromDate: (today.addDays(-14)).toISOString().substring(0, 10)
    //});
  }
  filterTestRequests(filterData : any) {
    this.onFilter.emit(filterData);
  }
}
